import { Edit } from '@/components/admin/edit';
import { SimpleForm } from '@/components/admin/simple-form';
import { TextInput } from '@/components/admin/text-input';
import { SelectInput } from '@/components/admin/select-input';

/**
 * ═══════════════════════════════════════════════════════════════════════════
 * **MODIFIER UN COMPTE — F-61, ET L'ADRESSE N'EST PAS DANS CE FORMULAIRE.**
 * ═══════════════════════════════════════════════════════════════════════════
 *
 * §6.14, colonne des champs interdits du `superadmin` : « **L'ADRESSE EMAIL EST INTERDITE EN
 * ÉCRITURE** ». F-61 : « **il ne change JAMAIS une adresse email** — borne acquise au domaine
 * des accès et **non élargie ici**. »
 *
 * **Trois verrous, et aucun n'est cet écran.** Le corps du contrat **ne porte pas le champ**,
 * donc le client généré refuse de le transmettre **à la compilation** ; le serveur répond
 * `400` sur un corps qui le porterait, `forbidNonWhitelisted` ; et le fournisseur de données
 * ne le transmet pas. L'absence du champ ici est la conséquence, pas la garde.
 *
 * Le seul chemin d'une adresse est celui de son titulaire : mot de passe courant **puis** code
 * à la nouvelle adresse, `CDC-4`.
 *
 * ───────────────────────────────────────────────────────────────────────────
 * **UNE STRUCTURE N'ATTEINT PAS CET ÉCRAN, ET LE MOTIF N'EST PAS UN NIVEAU DE DROIT.**
 * ───────────────────────────────────────────────────────────────────────────
 *
 * F-60 : « **UNE STRUCTURE NE TOUCHE JAMAIS UN COMPTE**, elle ne touche que des rattachements.
 * Elle ne modifie ni le nom, ni le prénom, ni l'adresse email, ni le rôle d'une personne, **et
 * elle ne l'anonymise pas**. Motif : **un compte appartient à la personne**, une structure
 * l'atteint par le rattachement, et **changer le rôle d'une personne le changerait chez toutes
 * ses structures**. »
 *
 * C'est cette dernière phrase qui rend la borne nécessaire et non prudentielle : le rôle est
 * **sur le compte**, pas sur le rattachement, donc une structure qui l'éditerait déciderait
 * pour les autres.
 *
 * ───────────────────────────────────────────────────────────────────────────
 * **TROIS RÔLES DANS LA LISTE, ET `SUPERADMIN` N'Y EST PAS.**
 * ───────────────────────────────────────────────────────────────────────────
 *
 * Le contrat borne `role` à `TUTOR`, `STUDENT`, `ORGADMIN`. **Le compte qui voit tout ne se
 * fabrique donc pas depuis cette surface**, et c'est cohérent avec §3 : il « n'a jamais de
 * rattachement, et il entre quand même » — c'est une exception explicite du produit, pas un
 * rôle qu'on distribue. La liste recopie le contrat plutôt que d'énumérer les quatre rôles
 * connus.
 *
 * **Attention à une conséquence que le corpus écrit ailleurs** : passer une personne à
 * `ORGADMIN` la soumet à Q534 — « un compte `orgadmin` porte **au plus un rattachement** » —,
 * et la route refuse alors par `ORGADMIN_RATTACHEMENT_UNIQUE` si elle en porte plusieurs.
 * C'est le serveur qui tranche ; l'aide de champ prévient.
 */
export function EditionDeCompte() {
  return (
    <Edit>
      <SimpleForm>
        <TextInput source="nom" label="Nom" />
        <TextInput source="prenom" label="Prénom" />
        <SelectInput
          source="role"
          label="Rôle"
          choices={[
            { id: 'TUTOR', name: 'Tuteur' },
            { id: 'STUDENT', name: 'Élève' },
            { id: 'ORGADMIN', name: 'Administre une structure' },
          ]}
          helperText="Le rôle vit sur le compte, donc il change chez toutes ses structures. Un compte qui administre une structure ne porte qu’un seul rattachement."
        />
      </SimpleForm>
    </Edit>
  );
}
